<template>
  <div class="flex content-section">
    <div class="w-full flex">
      <div
        v-show="sidebarVisible"
        style="min-width: 250px;"
        class="w-1/2 md:w-60 border-r absolute  md:relative bg-white z-20 md:-mt-4 pt-4  h-screen pr-2 text-sm mr-2"
      >
        <div class=" ">
          <form
            @submit="addFilters()"
            action="javascript:void(0)"
            class="flex flex-col space-y-2 w-full"
          >
            <div>
              <span class="flex-1">Modül</span>
              <div class="my-2">
                <select
                  v-model="selectedTable"
                  class="uk-select "
                  @change="getData('tableChange')"
                >
                  <option
                    v-if="table.reportable == 1"
                    v-for="table in $root.cache.tables"
                    :key="table.table"
                    :value="table"
                    >{{ table.name }}</option
                  >
                </select>
              </div>
              <span class="flex-1">Detaylı Arama </span>
              <span class="md:opacity-0 block md:hidden float-right text-tile">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                >
                  <path
                    fill="currentColor"
                    d="M17.414 16L24 9.414L22.586 8L16 14.586L9.414 8L8 9.414L14.586 16L8 22.586L9.414 24L16 17.414L22.586 24L24 22.586z"
                  />
                </svg>
              </span>
            </div>
            <template v-if="filters">
            <template v-if="filters.length > 0 && selectedTable">
              <div class="flex flex-col  items-start  text-sm my-2">
                <span
                  class="
                border-b
                flex
                justify-between
                space-x-2
                items-center 
                w-full 
                text-xs
                py-1 
              "
                  :key="filter.value"
                  v-for="filter in filters"
                >
                  <template v-if="fieldsMap[filter.name]">
                    <div class="flex space-x-2">
                      <span
                        class="
                        flex
                        items-center
                        space-y-2
                        flex-col
                        cursor-pointer
                        justify-center
                        filter-edit
                      "
                      >
                      <vk-icon
                          icon="pencil"
                          class="  hover:text-green-600"
                          ratio="0.6"
                          @click="filterEdit(filter)"
                        ></vk-icon>
                        <vk-icon
                          icon="close"
                          ratio="0.6"
                          class="hover:text-red-600"
                          @click="filterRemove(filter)"
                        ></vk-icon>
                      </span>

                      <b>{{ fieldsMap[filter.name].display_name }}</b>
                    </div>
                  </template>

                  <div class="flex space-x-2 items-center">
                    <span class="filter-label">
                      {{ filterTypeName(filter.type, filter.value, filter) }}
                    </span>
                    <span
                      class="
                  flex
                  items-center
                  cursor-pointer
                  justify-center
                  filter-close
                "
                    >
                      <vk-icon
                        icon="close"
                        ratio="0.6"
                        @click="filterRemove(filter)"
                      ></vk-icon>
                    </span>
                  </div>
                </span>
              </div>

              <span v-if="filterForm.editedId" class="text-sm mb-2"
                >Arama Kriteri Düzeltme</span
              >
              <span v-else class="text-sm mb-2">Yeni Arama Kriteri</span>
            </template>
          </template>

            <div>
              <select class="uk-select" v-model="filterForm.name">
                <option value="undefined" selected>Seçiniz</option>
                <option
                  :key="field.name"
                  v-for="field in fields"
                  :value="field.name"
                >
                  {{ field.display_name }}
                </option>
              </select>
            </div>

            <div>
              <select
                class="uk-select"
                v-if="fieldsMap[filterForm.name]"
                v-model="filterForm.type"
              >
                <option
                  :value="filterv.id"
                  :key="filterv.id"
                  v-for="filterv in filterTypes"
                >
                  {{ filterv.value }}
                </option>
              </select>
            </div>

            <template v-if="filterForm.name">
              <template v-if="filterForm.type == 11 || filterForm.type == 12">
                <search-item
                  :form="filterForm"
                  :multiple="true"
                  :value="filterForm.value"
                  :input="fieldsMap[filterForm.name]"
                  @changed="(returned) => (filterForm.value = returned.value)"
                  :type="fieldsMap[filterForm.name].component.name"
                />
              </template>
              <template
                v-else-if="
                  filterForm.type == 2 ||
                    filterForm.type == 3 ||
                    filterForm.type == 8 ||
                    filterForm.type == 9
                "
              >
                <input
                  type="text"
                  class="uk-input"
                  v-model="filterForm.value"
                  placeholder="Değer girin"
                />
              </template>
              <template v-else>
                <search-item
                  :form="filterForm"
                  :value="filterForm.value"
                  :input="fieldsMap[filterForm.name]"
                  @changed="(returned) => (filterForm.value = returned.value)"
                  :type="fieldsMap[filterForm.name].component.name"
                />
              </template>
            </template>

            <div class="flex space-x-2">
              <savebutton
                action="addFilters"
                v-if="filterForm.editedId"
                title="Güncelle"
              />
              <savebutton action="addFilters" v-else title="Ara" />
              <span
                class="global-button cursor-pointer"
                v-if="filterForm.editedId"
                @click="filterForm = []"
                >iptal</span
              >
            </div>
          </form>
        </div>
        <span class="font-medium block my-2">Kayıtlı Raporlar</span>
        <div v-if="savedReports" class="border rounded-lg divide-y">
          <span
            :key="sreport.id"
            v-for="sreport in savedReports.results"
            class="p-2 text-black block flex items-center justify-between"
          >
            <div @click="showReport(sreport)" class="cursor-pointer">
              {{ sreport.name }}
            </div>
            <a :href="'/reports#' + sreport.id" target="_blank">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="w-4 h-4"
                viewBox="0 0 24 24"
              >
                <path
                  fill="currentColor"
                  d="M6 18V2h16v16zm2-2h12V8h-7V4H8zm-6 6V6h2v14h14v2zM8 4v12z"
                />
              </svg>
            </a>
          </span>
        </div>
      </div>

      <div class="flex-1">
        <template v-if="loading">
          <div class="root">
            <div
              class="no-results flex mt-20 flex-col items-center justify-center"
            >
              <vk-spinner v-if="loading" ratio="4"></vk-spinner>
              <h2>Yükleniyor</h2>
              <span class="text-xs">Yükleniyor lütfen bekleyin</span>
            </div>
          </div>
        </template>

        <template v-else>
          <div class="min-h-screen rounded-lg">
            <form
              autocomplete="off"
              method="post"
              action="javascript:void(0)"
              @submit.prevent="multiSearch()"
            >
              <div class="border-b border-gray-200 mb-2  dark:border-gray-700">
                <ReportMonthly
                  :filters="filters"
                  :fields="fields"
                  :relations="relations"
                  :selectedTable="selectedTable"
                  :savedForm="savedForm"
                  :savedFormName="savedFormName"
                  :savedFormId="savedFormId"
                  :sidebarVisible="sidebarVisible"
                  @toggle-sidebar="sidebarVisible = !sidebarVisible"
                />
              </div>
            </form>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import httpService from "../../services/http";
import SearchItemVue from "../Ui/SearchItem.vue";
import EventBus from "../Ui/EventBus";
import FavoriteFilters from "./FavoriteFilters";
import ReportMonthly from "../../views/ReportMonthly.vue";
export default {
  name: "report-data-table",
  components: {
    "search-item": SearchItemVue,
    FavoriteFilters,
    ReportMonthly,
  },
  data() {
    return {
      sidebarVisible: true,
      favoriform: {},
      newReportForm: false,
      storedFilterSave: false,
      savedFormName: false,
      savedFormId: 0,
      favoriFormSave: false,
      filterName: null,
      tabId: null,
      multiFilterItem: [],
      relations: [],
      modalEditShow: false,
      modalEdit: [],
      filterTypes: [
        { id: 1, value: "Eşit olan" },
        { id: 2, value: "İçeren" },
        { id: 3, value: "İçermeyen" },
        { id: 4, value: "Büyük olan" },
        { id: 5, value: "Küçük olan" },
        { id: 6, value: "Büyük ve eşit olan" },
        { id: 7, value: "Küçük ve eşit olan" },
        { id: 8, value: "ile başlayan" },
        { id: 9, value: "ile biten" },
        { id: 10, value: "Arasındakiler" },
        { id: 11, value: "Birden fazla seçim" },
        { id: 12, value: "Birden fazla hariç tut" },
      ],
      loading: false,
      fields: {},
      selectedTable: null,
      bulkForm: {},
      bulkFormnew: null,
      fieldsMap: [],
      select_all: false,
      allFields: [],
      sideBarShow: false,
      fieldSearch: null,
      fieldConfig: false,
      savedForm: false,
      page: null,
      limit: 15,
      total: 200,
      allFieldsCheckbox: [],
      sort: {
        type: "desc",
        name: "id",
      },
      filters: [],
      selectedFilter: null,
      activeTab: "bekleyen",
      filterForm: {
        name: "",
        type: "",
        value: "",
      },
      tableHead: [],
      multiFilter: [],
      multiFilterStatus: false,
      tableData: [],
      selection: [],
      savedReports: [],
      filterToEdit: null,
    };
  },
  created() {
    this.getSavedReport();
    EventBus.$on("bottomMessage", this.getSavedReport);

    if (this.$route.query.q) {
      this.filters = [{ type: 2, name: "name", value: this.$route.query.q }];
    }
    const urlParams = new URLSearchParams(window.location.search);
    let queryParams = false;
    urlParams.forEach((value, key) => {
      // report_id ve category_id parametrelerini filtre olarak ekleme
      if (key === 'report_id' || key === 'category_id') {
        return;
      }
      queryParams = true;

      this.multiFilterItem[key] = value;
      if (Number.isInteger(value)) {
        this.filters.push({ type: 1, name: key, value: value });
      } else {
        this.filters.push({ type: 2, name: key, value: value });
      }
    });
  },

  watch: {
    $route(to, from) {
      // report_id değiştiyse raporu yükle
      if (to.query.report_id && to.query.report_id !== from.query.report_id) {
        if (this.savedReports && this.savedReports.results) {
          let sonuc = this.savedReports.results.find(
            (r) => r.id == to.query.report_id
          );
          if (sonuc) {
            this.showReport(sonuc);
            return;
          }
        }
      }

      this.routeCleaner();
      if (this.$route.query.q) {
        this.filters = [{ type: 2, name: "name", value: this.$route.query.q }];
      }
      this.getData("watch");
    },
    allFieldsCheckbox(data) {
      localStorage.setItem(
        this.selectedTable.table + "_allFieldsCheckbox",
        data
      );
    },
  },

  computed: {
    tableFieldsArray() {
      return this.tableHead;
    },
    allFieldsFiltered() {
      if (this.fieldSearch) {
        return Object.keys(this.allFields).filter((post) => {
          return post.toLowerCase().includes(this.fieldSearch.toLowerCase());
        });
      } else {
        return this.allFields;
      }
    },
  },
  beforeDestroy() {
    EventBus.$off("bottomMessage", this.getSavedReport);
  },
  methods: {
    filterEdit(item) {
      this.filterToEdit = item;
      this.filterForm = { ...item };
      this.filterForm.editedId = this.filters.indexOf(item) + 1;
      //   this.filters.splice(this.filters.indexOf(item), 1);
    },
    getSavedReport() {
      const urlParams = new URLSearchParams(window.location.search);
      const categoryId = urlParams.get('category_id');

      let filters = [];
      if (categoryId) {
        filters.push({ type: 1, name: 'category_id', value: parseInt(categoryId) });
      }

      httpService
        .getData({
          table: "reports",
          limit: 500,
          filters: filters
        })
        .then((e) => {
          this.savedReports = e.data;

          // Query parametresinden report_id kontrolü
          const reportId = this.$route.query.report_id;
          if (reportId && this.savedReports && this.savedReports.results) {
            let sonuc = this.savedReports.results.find(
              (r) => r.id == reportId
            );
            if (sonuc) {
              this.showReport(sonuc);
              return;
            }
          }

          // Hash'den rapor ID kontrolü (eski yöntem)
          if (window.location.hash.slice(1) > 0) {
            if (this.savedReports) {
              let sonuc = this.savedReports.results.find(
                (e) => e.id == window.location.hash.slice(1)
              );

              this.showReport(sonuc);
            }
          }
        });
    },
    newReportFormCall() {
      this.filters = [];
      this.selectedTable = [];
      this.newReportForm = true;
    },
    showReport(veri) {
      let data = JSON.parse(veri.report_values);
      this.selectedTable = this.$root.cache.tables.find(
        (e) => e.table == data.table
      );
      this.$forceUpdate();
      this.savedForm = data;
      this.savedFormName = veri.name;
      this.savedFormId = veri.id;
      this.favoriteFilterApply(data.filters);
      //window.location.hash = veri.id;
    },
    favoriteFilterApply(data) {
      this.filters = data;
      this.getData("favoriteFilterApply");
    },

    multiSearch() {
      if (!this.selectedTable || !this.selectedTable.table) {
        console.log("Lütfen önce bir tablo seçin");
        return;
      }

      const urlBuild = new URL(
        window.location.origin + window.location.pathname
      );

      this.filters = [];
      Object.keys(this.multiFilterItem).map((mp) => {
        if (this.multiFilterItem[mp]) {
          if (Number.isInteger(this.multiFilterItem[mp])) {
            this.filters.push({
              name: mp,
              value: this.multiFilterItem[mp],
              type: 1,
            });
          } else {
            this.filters.push({
              name: mp,
              value: this.multiFilterItem[mp],
              type: 2,
            });
          }

          urlBuild.searchParams.append(mp, this.multiFilterItem[mp]);
        }
      });
      history.pushState("", "", urlBuild.href);

      this.getData("multiSearch");
    },
    routeCleaner() {
      this.sort = {};
      this.selection = [];
      this.page = null;
      this.filterForm = [];
      this.filters = [];
      this.fieldsMap = [];
      this.tableData = [];
      this.tableHead = [];
      this.bulkForm = {};
      this.multiFilterItem = [];
    },
    getFieldDisplayName(key) {
      if (typeof this.fields === "object" && this.fields !== null) {
        let item = this.fields.find((e) => {
          return e.name == key;
        });

        if (item) {
          return item.display_name;
        }
      }
      return key;
    },
    filterTypeName(id, value, filter) {
      let returntext = "";
      if (this.filterTypes.find((e) => e.id == id)) {
        returntext += this.filterTypes.find((e) => e.id == id).value;
      }
      if (id == 10) {
        return returntext + " : " + value.start + " : " + value.end;
      } else {
        // Filter value'sunu label'a çevir
        const displayValue = this.getFilterDisplayValue(value, filter);
        return returntext + " : " + displayValue;
      }
    },
    getFilterDisplayValue(value, filter) {
      // filter yoksa veya name yoksa direkt value döndür
      if (!filter || !filter.name) {
        return value;
      }

      // fieldsMap'ten field bilgisini al
      const fieldInfo = this.fieldsMap[filter.name];
      if (!fieldInfo || !fieldInfo.id) {
        return value;
      }

      // Global options'dan label'ları çek
      const optionKey = fieldInfo.id;
      const options = this.$root.cache && this.$root.cache.getOptions && this.$root.cache.getOptions[optionKey];

      if (!options || !Array.isArray(options) || options.length === 0) {
        return value;
      }

      // Value array ise (multiple select)
      if (Array.isArray(value)) {
        const labels = value.map(id => {
          const option = options.find(opt => String(opt.value) === String(id));
          return option ? option.label : id;
        });
        return labels.join(', ');
      }

      // Value string ise ve virgül içeriyorsa (multiple select - string format)
      if (typeof value === 'string' && value.includes(',')) {
        const ids = value.split(',').map(id => id.trim());
        const labels = ids.map(id => {
          const option = options.find(opt => String(opt.value) === String(id));
          return option ? option.label : id;
        });
        return labels.join(', ');
      }

      // Tek değer için
      const option = options.find(opt => String(opt.value) === String(value));
      return option ? option.label : value;
    },
    setLimit() {
      this.limit = parseInt(this.limit);
      this.getData("setLimit");
    },
    changedAction(e) {
      this.bulkForm.new = e;
    },
    multiFilterFormValue(name) {
      if (name) {
        return Object.values(this.filters).find((e) => e.name == name);
      }
      return null;
    },
    multiFilterFormAdd(value, name) {
      this.multiFilterItem[name] = value;
    },
    filterRemove(item) {
      this.filters.splice(this.filters.indexOf(item), 1);
      this.getData("filterRemove");
    },
    addFilters() {
      if (this.filterForm.value) {
        if (this.filterForm.editedId) {
          this.filters.splice(this.filterForm.editedId - 1, 1);
        }
        this.filters.push(this.filterForm);
        this.filterForm = {
          name: "",
          type: "",
          value: "",
        };
        this.getData("addFilters");
      }
    },
    fieldConfigOpen() {
      this.fieldConfig = true;
      if (!this.allFieldsCheckbox) {
        this.allFieldsCheckbox = [];
        Object.values(this.allFields).forEach((field) => {
          if (this.tableHead[field]) {
            this.allFieldsCheckbox.push(field);
          }
        });
      }
    },
    getData(methodName) {
      if (!this.selectedTable || !this.selectedTable.table) {
        console.log("Tablo seçilmedi");
        return;
      }

      EventBus.$emit("loadingStatus", {
        action: methodName,
        loading: true,
      });

      this.$forceUpdate();

      this.loading = true;

      httpService
        .reportBuilderFields({
          table: this.selectedTable.table,
        })
        .then((response) => {
          this.fields = response.data.fields;

          this.fields.map((field) => {
            this.fieldsMap[field.name] = field;
          });

          this.relations = response.data.relations;
          this.loading = false;

          EventBus.$emit("loadingStatus", {
            action: methodName,
            loading: false,
            success: true,
          });
        })
        .catch(() => {
          console.log("yarıda kesildi");
        });
    },
    selectAll(checkboxs) {
      this.select_all = !this.select_all;
      if (this.select_all == true) {
        checkboxs.forEach((item) => {
          this.selection.push(item.id);
        });
      } else {
        this.selection = [];
      }
    },
    setSort(a) {
      this.sortType = a;
    },
    setSortItem(a) {
      if (this.sort.type == "asc") {
        this.sort.type = "desc";
      } else {
        this.sort.type = "asc";
      }
      this.sort.name = a;

      this.getData("setSortItem");
    },
  },
  mounted() {
    EventBus.$on("reflesh", () => {
      this.modalEditShow = false;
      this.getData("reflesh");
    });

    EventBus.$on("favoriteFilterApply", (data) => {
      this.modalEditShow = false;
      this.favoriteFilterApply(JSON.parse(data));
    });
  },
};
</script>
